export class VariantProductFieldsController {

  public static $inject = ['product'];
  public productBaseFields: any;
  public productSchemaFields: any;

  constructor(product: InterACT.Interfaces.Catalogues.Product) {
    this.productBaseFields = {
      name: product.name,
      description: product.description,
      retailReference: product.retailReference,
      type: product.type,
      stockItem: product.stockItem
    };
    this.productSchemaFields = product.fields;
  }
}